import { createSlice } from '@reduxjs/toolkit';

const canvasObjectStatesSlice = createSlice({
    name: 'canvasObjectStates',
    initialState: { objectActive: false, activeSelection: false, image: false, text: false },
    reducers: {
        setObjectsState: (state, action) => {
            const { objectActive, image, shadow, activeSelection, text } = action.payload;
            state.objectActive = objectActive;
            state.image = image;
            state.shadow = shadow;
            state.activeSelection = activeSelection;
            state.text = text;
        },
    },
});

export const { setObjectsState } = canvasObjectStatesSlice.actions;
export default canvasObjectStatesSlice.reducer;
